<template>
  <div class="row">
    <div class="col-lg-12" style="padding-top: 20px; padding-bottom: 20px">
      <div v-if="!generate" class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <!--buat csv-->
          <base-button @click="generate = true" class="btn-primary">Generate WCR</base-button>
        </div>
        <div class="col-lg-2 text-right" style="padding-top: 0.2%">
          <el-input type="search" class="mb-3 search-input" prefix-icon="el-icon-search"
            placeholder="Search reference no." v-model="searchQuery" aria-controls="datatables"></el-input>
        </div>
      </div>

      <div v-if="!generate" class="row" style="padding: 10px">
        <div class="col-lg">
          <div class="tabs">
            <div class="tab-list" style="display: flex">
              <div v-for="(tab, index) in tabs" :key="index" :class="{
                'first-tab': index === 0,
                'other-tab': index !== 0 && index !== 0,
                'last-tab': index === 1,
                'inactive-tab': activeTab !== index,
              }" @click="activeTab = index" style="z-index: 999">
                <p :class="{
                  'active-tab-title': activeTab === index,
                  'inactive-tab-title': activeTab !== index,
                }">
                  {{ tab.name }}
                </p>
              </div>
            </div>
            <card class="card-eprf">
              <div class="row">
                <div class="col-lg-6 text-left" v-if="activeTab == 1">
                </div>
                <div class="col-lg-6 text-left" v-if="activeTab == 0">
                  <base-button @click="createJob()" class="btn-primary">+ Create Job</base-button>
                  &nbsp;&nbsp;
                </div>
                <div class="col-lg-3 text-right" v-if="activeTab == 0">
                  Vendor:
                  <el-select placeholder="Vendor" v-model="selects.vendor" filterable @change="getData()">
                    <el-option v-for="option in selects.vendors" class="select-info custom-option" :value="option.value"
                      :label="option.label" :key="option.value"></el-option>
                  </el-select>
                </div>
                <div v-if="activeTab === 1" class="col-lg-3 text-right">
                  Customer:
                  <el-select placeholder="Status" v-model="selects.customer" filterable @change="getData()">
                    <el-option v-for="option in selects.customers" class="select-info custom-option"
                      :value="option.value" :label="option.label" :key="option.value"></el-option>
                  </el-select>
                </div>
                <div class="col-lg-3 text-right">
                  Status:
                  <el-select placeholder="Status" v-model="selects.status" filterable @change="getData()">
                    <el-option v-for="option in selects.statuses" class="select-info custom-option"
                      :value="option.value" :label="option.label" :key="option.value"></el-option>
                  </el-select>
                </div>
              </div>

              <div class="row">
                <div class="col-lg">
                  <!-- v-if="load" -->
                  <div id="tableku">
                    <el-table @sort-change="handleSorting" :data="tableDatas" style="width: 100%" :header-cell-style="{
                      background: 'transparent',
                      color: 'gray',
                    }" class="custom-table" :height="800" @row-click="clickkerowtu">
                      <el-table-column :min-width="50" align="center" prop="index" label="NO">
                      </el-table-column>
                      <el-table-column :min-width="200" align="center" prop="jobno" label="REFERENCE NO">
                        <div slot-scope="{ row }">
                          <p class="job-no-title" :style="{ color: colors.primary }" @click="getJobPage(row)">
                            {{ row.jobno }}
                          </p>
                        </div>
                      </el-table-column>
                      <el-table-column :min-width="200" sortable align="center" prop="datecreated" label="DATE CREATED">
                        <template slot-scope="{row}">
                          {{ moment(row.datecreated).format("DD-MM-YYYY") }}
                        </template>
                      </el-table-column>
                      <el-table-column v-if="activeTab == 1" :min-width="200" align="center" prop="customer"
                        label="CUSTOMER"></el-table-column>
                      <el-table-column v-if="activeTab == 0" :min-width="200" align="center" prop="vendor"
                        label="VENDOR"></el-table-column>
                      <el-table-column v-if="activeTab == 0" :min-width="200" sortable align="center"
                        prop="collectiondate" label="COLLECTION DATE">
                        <template slot-scope="{row}">
                          {{ moment(row.collectiondate).format("DD-MM-YYYY") }}
                        </template>
                      </el-table-column>
                      <el-table-column v-if="activeTab == 1" :min-width="200" sortable align="center" prop="readydate"
                        label="READY TO BE COLLECTED">
                        <template slot-scope="{row}">
                          {{ row.readydate != '-' ? moment(row.readydate).format("DD-MM-YYYY") : ''}}
                        </template>
                      </el-table-column>
                      <el-table-column :min-width="200" align="center" prop="status" label="STATUS">
                        <div slot-scope="{ row }">
                          <p :style="'color:' + row.statuscolor" :class="row.statuscode == 100 ? '' : 'job-no-title3'
                            " @click="
                              row.statuscode == 100
                                ? ''
                                : nextaction(row.outgoingid)
                              ">
                            {{ row.statusname }}
                          </p>
                        </div>
                      </el-table-column>

                      <el-table-column v-if="activeTab == 0" :min-width="200" align="center" prop="appointment"
                        label="APPOINTMENT">
                        <div slot-scope="{ row }">
                          <p :style="'color:' + row.appcolor" class="job-no-title3" @click="nextaction(row.outgoingid)">
                            {{ row.appname }}
                          </p>
                        </div>
                      </el-table-column>
                      <el-table-column :min-width="200" align="center" prop="ptw" label="PTW">
                        <div slot-scope="{ row }">
                          <p :style="'color:' + row.ptwcolor" class="job-no-title3" @click="nextaction(row.outgoingid)">
                            {{ row.ptwname }}
                          </p>
                        </div>
                      </el-table-column>
                      <!-- <el-table-column
                        v-if="activeTab == 1"
                        :min-width="200"
                        align="center"
                        label="DO"
                      >
                        <div slot-scope="{ row }">
                          <base-button class="btn-primary">VIEW DO</base-button>
                        </div>
                      </el-table-column> -->
                      <el-table-column v-if="activeTab == 0" :min-width="200" align="center" prop="cn" label="CN">
                        <div slot-scope="{ row }">
                          <p :style="'color:' + row.cncolor" class="job-no-title3" @click="nextaction(row.outgoingid)">
                            {{ row.cnname }}
                          </p>
                        </div>
                      </el-table-column>
                      <el-table-column v-if="activeTab == 0" :min-width="200" prop="invoice" label="INVOICE"
                        align="center">
                        <div slot-scope="{ row }">
                          <p v-if="positionid != 4" :style="'color:' + row.invoicecolor" class="job-no-title3"
                            @click="nextaction(row.outgoingid, 'edit')">
                            {{ row.invoicename }}
                          </p>
                          <p v-if="positionid == 4" :style="'color:' + row.invoicecolor" class="job-no-title3"
                            @click="nextaction(row.outgoingid, 'view')">
                            {{ row.invoicename }}
                          </p>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </card>
            <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <el-select v-model="pagination.perPage" placeholder="Per page">
                <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item"
                  :value="item"></el-option>
              </el-select>

              <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                :per-page="pagination.perPage" :total="pagination.total"></base-pagination>
            </div>
          </div>
        </div>
      </div>

      <div v-if="generate" class="row">
        <div class="col-lg-12 text-left">
          <base-button style="font-size: 18px" @click="generate = false" class="btn-link btn-primary">
            &lt; Back
          </base-button>
        </div>
      </div>

      <div v-if="generate" class="row">
        <!-- <div class="container vh-100 d-flex justify-content-center align-items-center"> -->
        <div class="col-lg"></div>
        <div class="col-lg-5">
          <card class="card-eprf">
            <div class="col-lg-12">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                WASTE COLLECTION REPORT
              </p>
              <div class="row" style="margin: 10px">
                <div class="col-lg-12 text-left">
                  <p style="color: #A5A5A5">Choose Service Location</p>
                </div>
              </div>
              <div class="row" style="margin: 10px">
                <div class="col-lg-12">
                  <el-select class="select-info tab select-width" placeholder="Select" v-model="selects.servicelocation"
                    style="width: 100%; border-bottom: 1px solid #aaa" filterable>
                    <el-option v-for="option in selects.servicelocations" class="select-info" :value="option.value"
                      :label="option.label" :key="option.value"></el-option>
                  </el-select>
                </div>
              </div>
              <br />
              <div class="row" style="margin: 10px">
                <div class="col-lg-12 text-left">
                  <p style="color: #A5A5A5">Choose Date Range</p>
                </div>
              </div>
              <div class="row" style="margin: 10px">
                <div class="col-lg-6">
                  <el-select class="select-info tab select-width" placeholder="Select Month" v-model="selects.month"
                    style="width: 100%; border-bottom: 1px solid #aaa" filterable>
                    <el-option v-for="option in selects.months" class="select-info" :value="option.value"
                      :label="option.label" :key="option.value"></el-option>
                  </el-select>
                </div>
                <div class="col-lg-6">
                  <el-date-picker type="year" v-model="selects.year" placeholder="Select Year"></el-date-picker>
                </div>
              </div>
              <br />
              <div class="d-flex justify-content-center spinner" v-if="generateload">
                <circle-8></circle-8>
              </div>
              <br />
              <div class="row">
                <div class="col-lg text-center">
                  <base-button @click="generateWCR" :disabled="cangenerate" class="btn-primary">Generate</base-button>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg"></div>
      </div>
      <!-- </div>  -->

      <modal :show.sync="modals.viewpdf" class="modal-large" :preventClose="true">
        <div class="row">
          <div class="col-lg text-right">
            <base-button class="btn-icon btn-round btn-cancel btn-sm" @click="modals.viewpdf = false"><i
                class="tim-icons icon-simple-remove"></i></base-button>
          </div>
        </div>
        <div class="row">
          <div class="col-lg">
            <p>{{ filepath }}</p>
          </div>
        </div>
      </modal>
      <!-- modal for dispute reasib -->
      <modal :show.sync="modals.disputereason" class="modal-eprf" centered>
        <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
          header="REASON FOR DISPUTE" header-bg-variant="primary" header-text-variant="white">
          <template #header>
            <div class="row">
              <div class="col-lg text-left">
                <h4 class="mb-0">REASON FOR DISPUTE</h4>
              </div>
              <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                <base-button class="btn-icon btn-cancel btn-round btn-sm">
                  <i style="
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    " class="tim-icons icon-simple-remove" @click="modals.disputereason = false"></i>
                </base-button>
              </div>
            </div>
          </template>

          <div class="row">
            <div class="col-lg-12">
              <textarea type="textarea" placeholder="Reason for rejection..." v-model="reason"
                :class="{ textarea: true }"></textarea>
            </div>
          </div>
        </b-card>
      </modal>
    </div>
  </div>
</template>

<script>
import {
  Alert,
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  Input,
} from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import util from "../../../util/util";
import Card from "../../../components/Cards/Card.vue";
import { Modal, ImageUpload, BasePagination, BaseSwitch } from "src/components";
import moment, { isDate } from "moment";
// import Fuse from "fuse.js";
import { debounce } from "src/util/debounce";
import { colors } from "../../../components/colors.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import LineChart from "src/components/Charts/LineChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";
import autoTable from "jspdf-autotable";
import Json2Excel from "src/components/Json2Excel/Json2Excel";
import * as XLSX from "sheetjs-style";
import { read, utils, writeFile } from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { tickStep } from "d3";

export default {
  name: "Outgoing",

  components: {
    Card,
    Modal,
    ImageUpload,
    [DatePicker.name]: DatePicker,
    [Input.name]: Input,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseSwitch,
    Circle8,
    [Select.name]: Select,
    [Option.name]: Option,
    // Fuse,
    html2canvas,
    LineChart,
    Json2Excel,
  },

  data() {
    return {
      generateload: false,
      logourl: "",
      locationname: "PORT RECEPTION FACILITY (PRF)",
      refno: "PRF/R/22/02/SA",
      datefor: "Jan - Dec 2023",
      daterange: "Jan - Dec 2023",
      grandtotal: "100000", //of what??
      lastyear: "2023",
      totalrow: 0,
      totalrows: 0,
      totalrowss: 0,
      months: [],

      monthname: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],

      summaries: [
        {
          waste: "SW 102\nSpent Batteries",
          gen: {
            value: 1,
            total: 12,
          },
          dis: {
            value: 2,
            total: 12,
          },
          sto: {
            value: 0,
            total: 12,
          },
          average: 100,
          jan: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          feb: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          mar: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          apr: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          may: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jun: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jul: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          aug: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          sep: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          oct: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          nov: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          dec: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
        },
        {
          waste: "SW 102\nSpent Batteries",
          gen: {
            value: 1,
            total: 12,
          },
          dis: {
            value: 2,
            total: 12,
          },
          sto: {
            value: 3,
            total: 12,
          },
          average: 100,
          jan: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          feb: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          mar: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          apr: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          may: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jun: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jul: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          aug: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          sep: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          oct: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          nov: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          dec: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
        },
        {
          waste: "SW 102\nSpent Batteries",
          gen: {
            value: 1,
            total: 12,
          },
          dis: {
            value: 2,
            total: 12,
          },
          sto: {
            value: 3,
            total: 12,
          },
          average: 100,
          jan: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          feb: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          mar: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          apr: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          may: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jun: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jul: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          aug: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          sep: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          oct: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          nov: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          dec: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
        },
        {
          waste: "SW 102\nSpent Batteries",
          gen: {
            value: 1,
            total: 12,
          },
          dis: {
            value: 2,
            total: 12,
          },
          sto: {
            value: 3,
            total: 12,
          },
          average: 100,
          jan: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          feb: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          mar: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          apr: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          may: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jun: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jul: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          aug: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          sep: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          oct: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          nov: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          dec: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
        },
        {
          waste: "SW 102\nSpent Batteries",
          gen: {
            value: 1,
            total: 12,
          },
          dis: {
            value: 2,
            total: 12,
          },
          sto: {
            value: 3,
            total: 12,
          },
          average: 100,
          jan: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          feb: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          mar: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          apr: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          may: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jun: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jul: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          aug: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          sep: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          oct: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          nov: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          dec: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
        },
        {
          waste: "SW 102\nSpent Batteries",
          gen: {
            value: 1,
            total: 12,
          },
          dis: {
            value: 2,
            total: 12,
          },
          sto: {
            value: 3,
            total: 12,
          },
          average: 100,
          jan: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          feb: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          mar: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          apr: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          may: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jun: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jul: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          aug: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          sep: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          oct: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          nov: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          dec: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
        },
        {
          waste: "SW 102\nSpent Batteries",
          gen: {
            value: 1,
            total: 12,
          },
          dis: {
            value: 2,
            total: 12,
          },
          sto: {
            value: 3,
            total: 12,
          },
          average: 100,
          jan: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          feb: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          mar: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          apr: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          may: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jun: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jul: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          aug: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          sep: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          oct: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          nov: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          dec: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
        },
        {
          waste: "SW 102\nSpent Batteries",
          gen: {
            value: 1,
            total: 12,
          },
          dis: {
            value: 2,
            total: 12,
          },
          sto: {
            value: 3,
            total: 12,
          },
          average: 100,
          jan: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          feb: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          mar: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          apr: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          may: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jun: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jul: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          aug: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          sep: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          oct: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          nov: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          dec: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
        },
        {
          waste: "SW 102\nSpent Batteries",
          gen: {
            value: 1,
            total: 12,
          },
          dis: {
            value: 2,
            total: 12,
          },
          sto: {
            value: 3,
            total: 12,
          },
          average: 100,
          jan: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          feb: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          mar: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          apr: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          may: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jun: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jul: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          aug: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          sep: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          oct: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          nov: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          dec: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
        },
        {
          waste: "SW 102\nSpent Batteries",
          gen: {
            value: 1,
            total: 12,
          },
          dis: {
            value: 2,
            total: 12,
          },
          sto: {
            value: 3,
            total: 12,
          },
          average: 100,
          jan: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          feb: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          mar: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          apr: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          may: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jun: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jul: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          aug: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          sep: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          oct: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          nov: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          dec: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
        },
        {
          waste: "SW 102\nSpent Batteries",
          gen: {
            value: 1,
            total: 12,
          },
          dis: {
            value: 2,
            total: 12,
          },
          sto: {
            value: 3,
            total: 12,
          },
          average: 100,
          jan: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          feb: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          mar: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          apr: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          may: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jun: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jul: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          aug: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          sep: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          oct: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          nov: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          dec: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
        },
        {
          waste: "SW 102\nSpent Batteries",
          gen: {
            value: 1,
            total: 12,
          },
          dis: {
            value: 2,
            total: 12,
          },
          sto: {
            value: 3,
            total: 12,
          },
          average: 100,
          jan: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          feb: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          mar: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          apr: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          may: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jun: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          jul: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          aug: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          sep: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          oct: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          nov: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
          dec: {
            gen: 1,
            dis: 2,
            sto: 3,
          },
        },
      ],

      cland: [
        { name: "sw101" },
        { name: "sw102" },
        { name: "sw103" },
        { name: "sw104" },
        { name: "sw105" },
      ],

      clands: [
        {
          name: "comp 1",
          date: "10/02/2024",
        },
        {
          name: "comp 2",
          date: "11/02/2024",
        },
        {
          name: "comp 3",
          date: "12/02/2024",
        },
        {
          name: "comp 4",
          date: "13/02/2024",
        },
        {
          name: "comp 5",
          date: "14/02/2024",
        },
      ],

      lands: [
        {
          name: "SW101",
        },
        {
          name: "SW102",
        },
        {
          name: "SW103",
        },
        {
          name: "SW104",
        },
        {
          name: "SW105",
        },
        {
          name: "SW106",
        },
      ],

      clandsvalue: [],
      allcland: [],

      landsvalue: [],
      vesselsvalue: [],

      allland: [],
      allvessel: [],

      vessels: [{ name: "Annex I" }, { name: "Annex II" }],

      location: [
        {
          name: "Asia Port",
          pic: "0123456789",
          date: "09/02/2024",
          land: [
            {
              name: "SW101",
              value: 100,
            },
            {
              name: "SW102",
              value: 100,
            },
          ],
          vessel: [
            {
              name: "Annex I",
              value: 100,
            },
          ],
        },
        {
          name: "RTG",
          pic: "0123456789",
          date: "09/02/2024",
          land: [
            {
              name: "SW101",
              value: 100,
            },
            {
              name: "SW102",
              value: 100,
            },
          ],
          vessel: [
            {
              name: "Annex I",
              value: 100,
            },
          ],
        },
        {
          name: "Terberg",
          pic: "0123456789",
          date: "09/02/2024",
          land: [
            {
              name: "SW101",
              value: 100,
            },
            {
              name: "SW102",
              value: 100,
            },
          ],
          vessel: [
            {
              name: "Annex I",
              value: 100,
            },
          ],
        },
        {
          name: "Cargotec",
          pic: "0123456789",
          date: "09/02/2024",
          land: [
            {
              name: "SW101",
              value: 100,
            },
            {
              name: "SW102",
              value: 100,
            },
          ],
          vessel: [
            {
              name: "Annex I",
              value: 100,
            },
          ],
        },
        {
          name: "ITP",
          pic: "0123456789",
          date: "09/02/2024",
          land: [
            {
              name: "SW101",
              value: 100,
            },
            {
              name: "SW102",
              value: 100,
            },
          ],
          vessel: [
            {
              name: "Annex I",
              value: 100,
            },
          ],
        },
      ],

      gggg: [],
      abc: null,
      ab: null,
      company: "",
      drivername: "",
      reportmonth: "",
      worksheet: null,
      // XLSX: null,
      workbook: null,
      worksheet2: null,
      filter: {
        download: "",
        downloads: [
          {
            label: "Januari",
            value: "Januari",
          },
          {
            label: "Februari",
            value: "Februari",
          },
        ],
      },
      searchQuery: "",
      tableData: [
        {
          driverid: 1,
          drivername: "Abu bin Ali",
          totalhourdrivinginmonth: "10.0",
          totalhourworkinginmonth: "12.0",
          totaltaskreceived: "5",
          totaltaskdeclined: "1",
          value: "",
        },
      ],
      summary: [
        {
          drivername: "Summary",
          totaldrivinghourpermonth: "176:23",
          totalworkinghourpermonth: "240",
          pcpsb: "45:45",
          pcldpe: "45:98",
          pcogd1: "78:78",
          pcogd2: "10:10",
        },
        {
          drivername: "Mohd Sahferi",
          totaldrivinghourpermonth: "176:23",
          totalworkinghourpermonth: "240",
          pcpsb: "45:45",
          pcldpe: "45:98",
          pcogd1: "78:78",
          pcogd2: "10:10",
          company: "swift",
          month: "July",
        },
        {
          drivername: "Siti Jenab",
          totaldrivinghourpermonth: "176:23",
          totalworkinghourpermonth: "240",
          pcpsb: "45:45",
          pcldpe: "45:98",
          pcogd1: "78:78",
          pcogd2: "10:10",
          company: "swift",
          month: "July",
        },
        {
          drivername: "Mak Minah",
          totaldrivinghourpermonth: "176:23",
          totalworkinghourpermonth: "240",
          pcpsb: "45:45",
          pcldpe: "45:98",
          pcogd1: "78:78",
          pcogd2: "10:10",
          company: "swift",
          month: "July",
        },
        {
          drivername: "Tipah",
          totaldrivinghourpermonth: "176:23",
          totalworkinghourpermonth: "240",
          pcpsb: "45:45",
          pcldpe: "45:98",
          pcogd1: "78:78",
          pcogd2: "10:10",
          company: "swift",
          month: "July",
        },
        {
          drivername: "mail",
          totaldrivinghourpermonth: "176:23",
          totalworkinghourpermonth: "240",
          pcpsb: "45:45",
          pcldpe: "45:98",
          pcogd1: "1111",
          pcogd2: "10:10",
          company: "swift",
          month: "July",
        },
      ],
      totals: [
        {
          totalhourdrivinginmonth: "10.0",
          totalhourworkinginmonth: "12.0",
          pcpsb: "45:45",
          pcldpe: "45:98",
          pcogd1: "78:78",
          pcogd2: "10:10",
          company: "swift",
          month: "July",
        },
      ],
      // tabs: [],
      hosbydriver: [],
      hosbydriverss: [],
      hosbydrivertotals: [],
      worksheet_tmp1: null,
      a: null,
      table: null,
      tbl0: null,
      tbl1: null,
      tbl2: null,
      tbl3: null,
      tbl4: null,
      tbl5: null,
      b: null,
      ba: null,
      bb: null,
      bc: null,
      bd: null,
      be: null,
      bf: null,

      XLSX: null,
      // workbook: null,
      // tableData: [],
      positionid: "",
      activeTab: "",
      colors: colors,
      tabs: [
        { name: "Waste", content: "Content for Tab 1" },
        { name: "Product", content: "Content for Tab 2" },
      ],
      selects: {
        date: "",
        vendor: "",
        vendors: [
          {
            label: "vendor A",
            value: "vendor A",
          },
          {
            label: "vendor B",
            value: "vendor B",
          },
        ],
        status: "",
        statuses: [],
        customer: "",
        customers: [],
        month: "",
        months: [
          {
            label: "January",
            value: 1,
          },
          {
            label: "February",
            value: 2,
          },
          {
            label: "March",
            value: 3,
          },
          {
            label: "April",
            value: 4,
          },
          {
            label: "May",
            value: 5,
          },
          {
            label: "June",
            value: 6,
          },
          {
            label: "July",
            value: 7,
          },
          {
            label: "August",
            value: 8,
          },
          {
            label: "September",
            value: 9,
          },
          {
            label: "October",
            value: 10,
          },
          {
            label: "November",
            value: 11,
          },
          {
            label: "December",
            value: 12,
          },
        ],
        year: "",
        years: [
          {
            label: "2024",
            value: 2024,
          },
        ],
        servicelocation: "",
        servicelocations: [],
      },
      pickerOptions: {
        disabledDate: () => false,
        onPick: ({ maxDate, minDate }) => {
          if (minDate) {
            const oneYearAfter = new Date(minDate);
            oneYearAfter.setFullYear(oneYearAfter.getFullYear() + 1);

            this.pickerOptions.disabledDate = (date) => {
              return date.getTime() > oneYearAfter.getTime();
            };
          } else {
            this.pickerOptions.disabledDate = () => false;
          }
        },
      },
      selectedFileName: "",
      allfilename: [],
      tableDatas: [
        // {
        //   jobno: "NPV211028002",
        //   datecreated: "14 Nov 2023",
        //   vendor: "Garuda Logistics Sdn Bhd",
        //   collectiondate: "14 Nov 2023",
        //   appointment: "Accepted",
        //   ptw: "-",
        //   cn: "-",
        //   cnfiles:
        //     "https://afes-eprf.s3.ap-southeast-1.amazonaws.com/signed-wdo/240605032622-Advance%20Notification%20Form.pdf",
        //   invoice: "View",
        //   status: 1,
        // },
        // {
        //   jobno: "NPV211028002",
        //   datecreated: "14 Nov 2023",
        //   vendor: "Garuda Logistics Sdn Bhd",
        //   collectiondate: "14 Nov 2023",
        //   appointment: "Accepted",
        //   ptw: "-",
        //   cn: "-",
        //   cnfiles:
        //     "https://afes-eprf.s3.ap-southeast-1.amazonaws.com/signed-wdo/240605032622-Advance%20Notification%20Form.pdf",
        //   invoice: "View",
        //   status: 2,
        // },
        // {
        //   jobno: "NPV211028002",
        //   datecreated: "14 Nov 2023",
        //   vendor: "Garuda Logistics Sdn Bhd",
        //   collectiondate: "14 Nov 2023",
        //   appointment: "Accepted",
        //   ptw: "Completed",
        //   cn: "Pending",
        //   cnfiles:
        //     "https://afes-eprf.s3.ap-southeast-1.amazonaws.com/signed-wdo/240605032622-Advance%20Notification%20Form.pdf",
        //   invoice: "View",
        //   status: 3,
        // },
        // {
        //   jobno: "NPV211028002",
        //   datecreated: "14 Nov 2023",
        //   vendor: "Garuda Logistics Sdn Bhd",
        //   collectiondate: "14 Nov 2023",
        //   appointment: "Accepted",
        //   ptw: "Completed",
        //   cn: "View",
        //   cnfiles:
        //     "https://afes-eprf.s3.ap-southeast-1.amazonaws.com/signed-wdo/240605032622-Advance%20Notification%20Form.pdf",
        //   invoice: "View",
        //   status: 4,
        // },
        // {
        //   jobno: "NPV211028002",
        //   datecreated: "14 Nov 2023",
        //   vendor: "Garuda Logistics Sdn Bhd",
        //   collectiondate: "14 Nov 2023",
        //   appointment: "Accepted",
        //   ptw: "Completed",
        //   cn: "View",
        //   cnfiles:
        //     "https://afes-eprf.s3.ap-southeast-1.amazonaws.com/signed-wdo/240605032622-Advance%20Notification%20Form.pdf",
        //   invoice: "View",
        //   status: 5,
        // },
        // {
        //   jobno: "NPV211028002",
        //   datecreated: "14 Nov 2023",
        //   vendor: "Garuda Logistics Sdn Bhd",
        //   collectiondate: "14 Nov 2023",
        //   appointment: "Accepted",
        //   ptw: "Completed",
        //   cn: "View",
        //   cnfiles:
        //     "https://afes-eprf.s3.ap-southeast-1.amazonaws.com/signed-wdo/240605032622-Advance%20Notification%20Form.pdf",
        //   invoice: "View",
        //   status: 6,
        // },
      ],

      // load: false,

      jobno: [
        {
          prop: "jobno",
          label: "REFERENCE NO",
        },
      ],
      joblist: [
        {
          prop: "vendor",
          label: "VENDOR",
        },
        {
          prop: "collectiondate",
          label: "COLLECTION DATE",
        },
      ],

      temp: [],
      // searchQuery: "",
      searchedData: [],
      // fuseSearch: null,
      currentRow: "",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 25, 50],
        total: 0,
      },
      modals: {
        viewpdf: false,
        disputereason: false,
      },
      filepath: "",
      flag: false,
      page: 1,
      reason: "",
      producttype: "",

      generate: false,

      sortTable: '',
      orderTable: '',
    };
  },
  methods: {
    handleSorting({ column, prop, order }) {
      console.log('producttype', this.producttype);
      console.log(`prop ${prop} order ${order}`);

      this.sortTable = (prop == 'datecreated' ? 'created_at' :  prop == 'readydate' ? 'order_ready_at' : 'order_ready_at');
      this.orderTable = (order == 'ascending' ? 'asc' : 'desc');

      if (prop == 'readydate') {
        this.producttype == 'products';
      } else {
        this.producttype == 'waste';  
      }

      this.getData();
    },
    getServiceLocation() {
      this.selects.servicelocations = [];

      this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              value: response[i].ServiceLocationId,
              label: response[i].Location,
            };

            this.selects.servicelocations.push(obj);
          }
          console.log(this.selects.servicelocations);
        }
      });
    },
    getStatus() {
      this.selects.statuses = [];

      let att = "";

      if (this.producttype == "waste") {
        att = "waste";
      } else if (this.producttype == "products") {
        att = "product";
      }
      console.log(this.producttype);
      this.$http
        .get(":10001/api/v1/status/outgoing?type=" + att)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            for (var i = 0; i < response.length; i++) {
              let obj = {
                label: response[i].status,
                value: response[i].value,
              };
              this.selects.statuses.push(obj);
            }

            this.selects.status = this.selects.statuses[0].value;
          }
        });
    },
    getCustomer() {
      this.selects.customers = [];

      this.$http
        .get(":10001/api/v1/outgoing/product/customer")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            let objj = {
              label: 'All Customer',
              value: '',
            }
            this.selects.customers.push(objj);

            for (var i = 0; i < response.length; i++) {
              let obj = {
                label: response[i].company_name,
                value: response[i].company_id,
              };
              this.selects.customers.push(obj);
            }

            this.selects.customer = this.selects.customers[0].value;
          }
        });
    },
    clickkerowtu(e) {
      console.log(e);
      if (this.producttype == "waste") {
        this.$router.push("/OutgoingJobPage/" + e.outgoingid + "/edit");
      }
      if (this.producttype == "products") {
        this.$router.push("/Outgoing/" + e.outgoingid);
      }
    },
    getVendor() {
      this.selects.vendors = [{ label: "All Vendor", value: "" }];
      this.$http.get(":10001/api/v1/user-management/vendor").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].company_name,
              value: response[i].company_id,
            };
            this.selects.vendors.push(obj);
          }
        }
      });
    },

    loadImageAsBase64(imageUrl) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = function () {
          const reader = new FileReader();
          reader.onloadend = function () {
            resolve(reader.result);
          };
          reader.readAsDataURL(xhr.response);
        };
        xhr.open("GET", imageUrl);
        xhr.responseType = "blob";
        xhr.send();
      });
    },

    async generateWCR() {
      this.generateload = true;
      this.summaries = [];
      this.months = [];
      this.location = [];
      this.lands = [];
      this.vessels = [];
      this.clandsvalue = [];
      this.landsvalue = [];
      this.vesselsvalue = [];
      this.allcland = [];
      this.allland = [];
      this.allvessel = [];
      this.cland = [];
      this.clands = [];

      await this.$http
        .get(
          `:10001/api/v1/report/wcr?service_location_id=${this.selects.servicelocation
          }&year=${moment(this.selects.year).format("YYYY")}&month=${this.selects.month
          }`
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.logourl = require("@/assets/img/afesnew.png");
            // this.logourl = response.service_location.logo.url,
            this.locationname = response.service_location.location;
            this.datefor = response.generated_for;
            this.refno = response.reference_number;

            for (let j = 0; j < 12; j++) {
              console.log(
                `${response.SectionA[0] == null
                  ? "-"
                  : response.SectionA[0].month == null
                    ? "-"
                    : response.SectionA[0].month[0].year
                }`
              );
              let month = `${this.monthname[j]} ${response.SectionA[0] == null
                ? "-"
                : response.SectionA[0].month == null
                  ? "-"
                  : response.SectionA[0].month[0].year
                }`;
              this.months.push(month);
            }

            if (response.SectionA != null)
              for (let i = 0; i < response.SectionA.length; i++) {
                let gentotal = 0;
                let distotal = 0;
                let stototal = 0;

                for (let j = 0; j < response.SectionA[i].month.length; j++) {
                  gentotal += response.SectionA[i].month[j].data.gen;
                  distotal += response.SectionA[i].month[j].data.dis;
                  stototal += response.SectionA[i].month[j].data.sto;
                }

                let obj = {
                  waste: response.SectionA[i].name,
                  gen: {
                    value: 1,
                    total: gentotal,
                  },
                  dis: {
                    value: 2,
                    total: distotal,
                  },
                  sto: {
                    value: response.SectionA[i].last_year_balance.sto,
                    total: response.SectionA[i].last_year_balance.sto,
                  },
                  average: gentotal / response.SectionA[i].month.length,
                  jan: {
                    gen:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[0] == null
                          ? "-"
                          : response.SectionA[i].month[0].data.gen,
                    dis:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[0] == null
                          ? "-"
                          : response.SectionA[i].month[0].data.dis,
                    sto:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[0] == null
                          ? "-"
                          : response.SectionA[i].month[0].data.sto,
                  },
                  feb: {
                    gen:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[1] == null
                          ? "-"
                          : response.SectionA[i].month[1].data.gen,
                    dis:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[1] == null
                          ? "-"
                          : response.SectionA[i].month[1].data.dis,
                    sto:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[1] == null
                          ? "-"
                          : response.SectionA[i].month[1].data.sto,
                  },
                  mar: {
                    gen:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[2] == null
                          ? "-"
                          : response.SectionA[i].month[2].data.gen,
                    dis:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[2] == null
                          ? "-"
                          : response.SectionA[i].month[2].data.dis,
                    sto:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[2] == null
                          ? "-"
                          : response.SectionA[i].month[2].data.sto,
                  },
                  apr: {
                    gen:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[3] == null
                          ? "-"
                          : response.SectionA[i].month[3].data.gen,
                    dis:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[3] == null
                          ? "-"
                          : response.SectionA[i].month[3].data.dis,
                    sto:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[3] == null
                          ? "-"
                          : response.SectionA[i].month[3].data.sto,
                  },
                  may: {
                    gen:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[4] == null
                          ? "-"
                          : response.SectionA[i].month[4].data.gen,
                    dis:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[4] == null
                          ? "-"
                          : response.SectionA[i].month[4].data.dis,
                    sto:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[4] == null
                          ? "-"
                          : response.SectionA[i].month[4].data.sto,
                  },
                  jun: {
                    gen:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[5] == null
                          ? "-"
                          : response.SectionA[i].month[5].data.gen,
                    dis:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[5] == null
                          ? "-"
                          : response.SectionA[i].month[5].data.dis,
                    sto:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[5] == null
                          ? "-"
                          : response.SectionA[i].month[5].data.sto,
                  },
                  jul: {
                    gen:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[6] == null
                          ? "-"
                          : response.SectionA[i].month[6].data.gen,
                    dis:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[6] == null
                          ? "-"
                          : response.SectionA[i].month[6].data.dis,
                    sto:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[6] == null
                          ? "-"
                          : response.SectionA[i].month[6].data.sto,
                  },
                  aug: {
                    gen:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[7] == null
                          ? "-"
                          : response.SectionA[i].month[7].data.gen,
                    dis:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[7] == null
                          ? "-"
                          : response.SectionA[i].month[7].data.dis,
                    sto:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[7] == null
                          ? "-"
                          : response.SectionA[i].month[7].data.sto,
                  },
                  sep: {
                    gen:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[8] == null
                          ? "-"
                          : response.SectionA[i].month[8].data.gen,
                    dis:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[8] == null
                          ? "-"
                          : response.SectionA[i].month[8].data.dis,
                    sto:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[8] == null
                          ? "-"
                          : response.SectionA[i].month[8].data.sto,
                  },
                  oct: {
                    gen:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[9] == null
                          ? "-"
                          : response.SectionA[i].month[9].data.gen,
                    dis:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[9] == null
                          ? "-"
                          : response.SectionA[i].month[9].data.dis,
                    sto:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[9] == null
                          ? "-"
                          : response.SectionA[i].month[9].data.sto,
                  },
                  nov: {
                    gen:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[10] == null
                          ? "-"
                          : response.SectionA[i].month[10].data.gen,
                    dis:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[10] == null
                          ? "-"
                          : response.SectionA[i].month[10].data.dis,
                    sto:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[10] == null
                          ? "-"
                          : response.SectionA[i].month[10].data.sto,
                  },
                  dec: {
                    gen:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[11] == null
                          ? "-"
                          : response.SectionA[i].month[11].data.gen,
                    dis:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[11] == null
                          ? "-"
                          : response.SectionA[i].month[11].data.dis,
                    sto:
                      response.SectionA[i] == null
                        ? "-"
                        : response.SectionA[i].month[11] == null
                          ? "-"
                          : response.SectionA[i].month[11].data.sto,
                  },
                };

                this.summaries.push(obj);
              }

            if (response.SectionB != null)
              for (let i = 0; i < response.SectionB.length; i++) {
                for (
                  let j = 0;
                  j < response.SectionB[i].land_generated.length;
                  j++
                ) {
                  let obji = {
                    name: response.SectionB[i].land_generated[j].name,
                  };

                  if (!this.lands.some((land) => land.name === obji.name)) {
                    this.lands.push(obji);
                  }
                }

                for (
                  let j = 0;
                  j < response.SectionB[i].vessel_generated.length;
                  j++
                ) {
                  let objjk = {
                    name: response.SectionB[i].vessel_generated[j].name,
                  };

                  if (
                    !this.vessels.some((vessel) => vessel.name === objjk.name)
                  ) {
                    this.vessels.push(objjk);
                  }
                }
              }

            //check b n c null
            if (response.SectionB != null)
              for (let i = 0; i < response.SectionB.length; i++) {
                this.landsvalue = new Array(this.lands.length).fill({});
                for (
                  let j = 0;
                  j < response.SectionB[i].land_generated.length;
                  j++
                ) {
                  let objjj = {
                    name: response.SectionB[i].land_generated[j].name,
                    value: response.SectionB[i].land_generated[j].amount,
                  };

                  let index = this.lands.findIndex(
                    (landObj) => landObj.name === objjj.name
                  );
                  if (index !== -1) {
                    this.landsvalue[index] = objjj;
                  }
                }

                this.vesselsvalue = new Array(this.vessels.length).fill({});
                for (
                  let j = 0;
                  j < response.SectionB[i].vessel_generated.length;
                  j++
                ) {
                  let objs = {
                    name: response.SectionB[i].vessel_generated[j].name,
                    value: response.SectionB[i].vessel_generated[j].amount,
                  };
                  let indexi = this.vessels.findIndex(
                    (vesselObj) => vesselObj.name === objs.name
                  );
                  if (indexi !== -1) {
                    this.vesselsvalue[indexi] = objs;
                  }
                }

                let obj = {
                  name: response.SectionB[i].company_name,
                  pic: response.SectionB[i].pic_no,
                  date: moment(response.SectionB[i].collection_date).format(
                    "DD/MM/YYYY"
                  ),
                  land: this.landsvalue,
                  vessel: this.vesselsvalue,
                };

                this.location.push(obj);

                this.allland.push(this.landsvalue);
                this.allvessel.push(this.vesselsvalue);
              }

            //listing bhgian tepi
            if (response.SectionC != null)
              for (let i = 0; i < response.SectionC.length; i++) {
                for (
                  let j = 0;
                  j < response.SectionC[i].land_generated.length;
                  j++
                ) {
                  let objij = {
                    name: response.SectionC[i].land_generated[j].name,
                  };

                  if (!this.cland.some((land) => land.name === objij.name)) {
                    this.cland.push(objij);
                  }
                }
              }

            if (response.SectionC != null)
              for (let i = 0; i < response.SectionC.length; i++) {
                this.clandsvalue = new Array(this.cland.length).fill({});
                for (
                  let j = 0;
                  j < response.SectionC[i].land_generated.length;
                  j++
                ) {
                  let objjj = {
                    name: response.SectionC[i].land_generated[j].name,
                    value: response.SectionC[i].land_generated[j].amount,
                  };

                  let index = this.cland.findIndex(
                    (landObj) => landObj.name === objjj.name
                  );
                  if (index !== -1) {
                    this.clandsvalue[index] = objjj;
                  }
                }

                let objes = {
                  company: response.SectionC[i].company_name,
                  pic: response.SectionC[i].pic_no,
                  date: moment(response.SectionC[i].order_ready_at).format(
                    "DD/MM/YYYY"
                  ),
                  land: this.clandsvalue,
                };

                this.clands.push(objes);

                this.allcland.push(this.clandsvalue);
              }

            this.totalrow = Math.ceil(this.summaries.length / 3);
            this.totalrows = Math.ceil(this.location.length / 4);
            this.totalrowss = Math.ceil(this.clands.length / 4);

            this.generateload = false;
          }
        });

      this.downloadExcell();
    },

    async downloadExcell() {
      const ExcelJS = require("exceljs");
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      //header start here
      const imageUrl = this.logourl;
      const image = await this.loadImageAsBase64(imageUrl);

      const imageId = workbook.addImage({
        base64: image,
        extension: "png",
      });

      worksheet.addImage(imageId, {
        tl: { col: 0, row: 0 },
        ext: { width: 190, height: 80 },
      });

      worksheet.getCell("C1").value =
        "Alam Flora Environmental Solutions Sdn Bhd";
      worksheet.getCell("C1").font = {
        bold: true,
        color: { argb: "FF707070" },
      };
      worksheet.getCell("C1").protection = {
        locked: true,
      };
      worksheet.getCell("C2").value =
        "Level 2, EON Head Office Complex, No. 2, Persiaran Kerjaya U1, 40150 Shah Alam, Selangor Darul Ehsan";
      worksheet.getCell("C2").font = { color: { argb: "FF707070" } };
      worksheet.getCell("C2").protection = {
        locked: true,
      };
      worksheet.getCell("C3").value = "Tel : (603) 7803 0518";
      worksheet.getCell("C3").font = { color: { argb: "FF707070" } };
      worksheet.getCell("C2").protection = {
        locked: true,
      };
      worksheet.getCell("C4").value = "Web : www.afes.com.my";
      worksheet.getCell("C4").font = { color: { argb: "FF707070" } };
      worksheet.getCell("C4").protection = {
        locked: true,
      };
      worksheet.getCell(
        "A6"
      ).value = `${this.locationname} - WASTE COLLECTION REPORT (WCR)`;
      worksheet.getCell("A6").font = {
        bold: true,
        color: { argb: "FF358CCB" },
      };
      worksheet.getCell("A6").protection = {
        locked: true,
      };
      worksheet.getCell("A7").value = "Date:";
      worksheet.getCell("A7").font = {
        bold: true,
        color: { argb: "FF000000" },
      };
      worksheet.getCell("A7").protection = {
        locked: true,
      };
      worksheet.getCell("A8").value = "Ref No:";
      worksheet.getCell("A8").font = {
        bold: true,
        color: { argb: "FF000000" },
      };
      worksheet.getCell("A8").protection = {
        locked: true,
      };
      worksheet.getCell("B7").value = this.datefor;
      worksheet.getCell("B7").font = { color: { argb: "FF707070" } };
      worksheet.getCell("B7").protection = {
        locked: true,
      };
      worksheet.getCell("B8").value = this.refno;
      worksheet.getCell("B8").font = { color: { argb: "FF707070" } };
      worksheet.getCell("B8").protection = {
        locked: true,
      };
      worksheet.getCell("A10").value = "WASTE GENERATOR INFORMATION";
      worksheet.getCell("A10").font = {
        bold: true,
        color: { argb: "FF358CCB" },
      };
      worksheet.getCell("A10").protection = {
        locked: true,
      };
      worksheet.getCell("A11").value = "Company Name:";
      worksheet.getCell("A11").font = {
        bold: true,
        color: { argb: "FF000000" },
      };
      worksheet.getCell("A11").protection = {
        locked: true,
      };
      worksheet.getCell("A12").value = "PIC:";
      worksheet.getCell("A12").font = {
        bold: true,
        color: { argb: "FF000000" },
      };
      worksheet.getCell("A12").protection = {
        locked: true,
      };
      //header end here

      //section a start here
      let start = 14;
      let startt = 15;
      let starttt = 16;
      let startcul = 30;
      let startavg = 31;
      let starttot = 32;

      let startmonth = 18;

      const rowIncrement = 19;
      const columns = ["B", "E", "H"];
      const columnss = ["C", "F", "I"];
      const columnsss = ["D", "G", "J"];

      const rowIncrementt = this.lands.length + this.vessels.length + 4;

      //section a end here

      //section b start here
      const columnb = ["C", "E", "G", "I"];
      //section b end here

      let grandrow = start;
      for (let i = start; i < rowIncrement * this.totalrow; i += rowIncrement) {
        worksheet.mergeCells(i, 1, i, 10);
        worksheet.getCell(`A${i}`).value =
          "SECTION A : SUMMARY OF PRF INVENTORY";
        worksheet.getCell(`A${i}`).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(`A${i}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF358CCB" },
        };

        grandrow = i;
      }

      let startsectionb = grandrow + 20;

      worksheet.mergeCells(startsectionb, 1, startsectionb, 10);
      worksheet.getCell(`A${startsectionb}`).value =
        "SECTION B : COLLECTION FROM NMB TO PRF";
      worksheet.getCell(`A${startsectionb}`).font = {
        color: { argb: "FFFFFFFF" },
      };
      worksheet.getCell(`A${startsectionb}`).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF358CCB" },
      };

      let ii = startsectionb + 1;
      let j = startsectionb + 2;
      let vv = ii + 2 + this.lands.length;

      let kg = j + 2;
      let kgg = startsectionb + 5 + this.lands.length;

      for (let i = 0; i < this.totalrows; i++) {
        worksheet.mergeCells(ii, 1, ii, 2);
        worksheet.getCell(`A${ii}`).value = "Land Generated - Scheduled Waste";
        worksheet.getCell(`A${ii}`).alignment = { horizontal: "left" };
        worksheet.getCell(`A${ii}`).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(`A${ii}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`A${ii}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        console.log("vessel", vv);
        worksheet.mergeCells(vv + 1, 1, vv + 1, 10);
        worksheet.getCell(`A${vv + 1}`).value = "Vessel Generated";
        worksheet.getCell(`A${vv + 1}`).alignment = { horizontal: "left" };
        worksheet.getCell(`A${vv + 1}`).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(`A${vv + 1}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`A${vv + 1}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        worksheet.mergeCells(j, 2, j + 1, 2);
        worksheet.getCell(`B${j}`).value = "Unit";
        worksheet.getCell(`B${j}`).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
        worksheet.getCell(`B${j}`).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(`B${j}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`B${j}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        worksheet.mergeCells(kgg, 2, kgg + this.vessels.length - 1, 2);
        worksheet.getCell(`B${kgg}`).value = "Kg";
        worksheet.getCell(`B${kgg}`).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
        worksheet.getCell(`B${kgg}`).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(`B${kgg}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`B${kgg}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        worksheet.mergeCells(kg, 2, kg + this.lands.length - 1, 2);
        worksheet.getCell(`B${kg}`).value = "Kg";
        worksheet.getCell(`B${kg}`).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
        worksheet.getCell(`B${kg}`).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(`B${kg}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`B${kg}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        worksheet.mergeCells(j, 1, j + 1, 1);
        worksheet.getCell(`A${j}`).value = "Waste Code & Name";
        worksheet.getCell(`A${j}`).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
        worksheet.getCell(`A${j}`).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(`A${j}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`A${j}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        j += rowIncrementt;
        ii += rowIncrementt;
        vv += rowIncrementt;
        kg += rowIncrementt;
        kgg += rowIncrementt;
      }

      let cccc = startsectionb + 3;
      let dddd = startsectionb + 4 + this.lands.length;

      //value dalam table styling land
      for (let j = 1; j <= this.landsvalue.length; j++) {
        let startmergec = cccc + j;
        console.log("merging c", startmergec);
        for (let i = 0; i < this.totalrows; i++) {
          worksheet.mergeCells(startmergec, 3, startmergec, 4);
          worksheet.mergeCells(startmergec, 5, startmergec, 6);
          worksheet.mergeCells(startmergec, 7, startmergec, 8);
          worksheet.mergeCells(startmergec, 9, startmergec, 10);

          worksheet.getCell(`C${startmergec}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`C${startmergec}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
          worksheet.getCell(`E${startmergec}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`E${startmergec}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
          worksheet.getCell(`G${startmergec}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`G${startmergec}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
          worksheet.getCell(`I${startmergec}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`I${startmergec}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };

          startmergec += rowIncrementt;
        }
      }

      //value dalam table styling vessel
      for (let j = 1; j <= this.vesselsvalue.length; j++) {
        let startmergec = dddd + j;
        console.log("merging c", startmergec);
        for (let i = 0; i < this.totalrows; i++) {
          worksheet.mergeCells(startmergec, 3, startmergec, 4);
          worksheet.mergeCells(startmergec, 5, startmergec, 6);
          worksheet.mergeCells(startmergec, 7, startmergec, 8);
          worksheet.mergeCells(startmergec, 9, startmergec, 10);

          worksheet.getCell(`C${startmergec}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`C${startmergec}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
          worksheet.getCell(`E${startmergec}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`E${startmergec}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
          worksheet.getCell(`G${startmergec}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`G${startmergec}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
          worksheet.getCell(`I${startmergec}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`I${startmergec}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };

          startmergec += rowIncrementt;
        }
      }

      let landstart = startsectionb + 4;
      for (let i = 0; i < this.totalrows; i++) {
        //belah tepi
        this.lands.forEach((land, index) => {
          const row = landstart + index;
          worksheet.getCell(`A${row}`).value = land.name;
          worksheet.getCell(`A${row}`).alignment = {
            wrapText: true,
            vertical: "middle",
          };
          worksheet.getCell(`A${row}`).font = { color: { argb: "FF707070" } };
          worksheet.getCell(`A${row}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`A${row}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
        });

        landstart += rowIncrementt;

        //sini value in table b
        let landstartt = startsectionb + 4;
        this.allland.forEach((loc, index) => {
          const columnIndex = index % 4;
          const column = columnb[columnIndex];
          const rowss = landstartt + Math.floor(index / 4) * rowIncrementt;
          const cell = `${column}${rowss}`;

          let rowing = rowss;

          for (let i = 0; i < this.landsvalue.length; i++) {
            worksheet.getCell(`${column}${rowing}`).value =
              loc[i].value == null ? "" : loc[i].value;
            worksheet.getCell(`${column}${rowing}`).alignment = {
              horizontal: "center",
              vertical: "middle",
            };
            worksheet.getCell(`${column}${rowing}`).font = {
              color: { argb: "FF707070" },
            };
            worksheet.getCell(`${column}${rowing}`).fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFF5F6FA" },
            };
            worksheet.getCell(`${column}${rowing}`).border = {
              top: { style: "thin", color: { argb: "FFFFFFFF" } },
              bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
              left: { style: "thin", color: { argb: "FFFFFFFF" } },
              right: { style: "thin", color: { argb: "FFFFFFFF" } },
            };

            rowing++;
          }
        });

        let vesselstartt = startsectionb + 5 + this.lands.length;
        this.allvessel.forEach((loc, index) => {
          const columnIndex = index % 4;
          const column = columnb[columnIndex];
          const rowss = vesselstartt + Math.floor(index / 4) * rowIncrementt;
          const cell = `${column}${rowss}`;

          let rowingg = rowss;

          for (let i = 0; i < this.vesselsvalue.length; i++) {
            worksheet.getCell(`${column}${rowingg}`).value =
              loc[i].value == null ? "" : loc[i].value;
            worksheet.getCell(`${column}${rowingg}`).alignment = {
              horizontal: "center",
              vertical: "middle",
            };
            worksheet.getCell(`${column}${rowingg}`).font = {
              color: { argb: "FF707070" },
            };
            worksheet.getCell(`${column}${rowingg}`).fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFF5F6FA" },
            };
            worksheet.getCell(`${column}${rowingg}`).border = {
              top: { style: "thin", color: { argb: "FFFFFFFF" } },
              bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
              left: { style: "thin", color: { argb: "FFFFFFFF" } },
              right: { style: "thin", color: { argb: "FFFFFFFF" } },
            };

            rowingg++;
          }
        });
      }

      let vesselstart = startsectionb + 5 + this.lands.length;
      for (let i = 0; i < this.totalrows; i++) {
        //belah tepi
        this.vessels.forEach((vessel, index) => {
          const row = vesselstart + index;
          worksheet.getCell(`A${row}`).value = vessel.name;
          worksheet.getCell(`A${row}`).alignment = {
            wrapText: true,
            vertical: "middle",
          };
          worksheet.getCell(`A${row}`).font = { color: { argb: "FF707070" } };
          worksheet.getCell(`A${row}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`A${row}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
        });
        vesselstart += rowIncrementt;
      }

      let startname = startsectionb + 1;
      let startpic = startsectionb + 2;
      let startdate = startsectionb + 3;

      this.location.forEach((loc, index) => {
        const columnIndex = index % 4;
        const column = columnb[columnIndex];
        const rowss = startname + Math.floor(index / 4) * rowIncrementt;
        const cell = `${column}${rowss}`;
        worksheet.getCell(cell).value = loc.name;
        worksheet.getCell(cell).alignment = { horizontal: "center" };
        worksheet.getCell(cell).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      });

      this.location.forEach((loc, index) => {
        const columnIndex = index % 4;
        const column = columnb[columnIndex];
        const rowss = startpic + Math.floor(index / 4) * rowIncrementt;
        const cell = `${column}${rowss}`;
        worksheet.getCell(cell).value = `PIC No: ${loc.pic}`;
        worksheet.getCell(cell).alignment = { horizontal: "center" };
        worksheet.getCell(cell).font = { color: { argb: "FF707070" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      });

      this.location.forEach((loc, index) => {
        const columnIndex = index % 4;
        const column = columnb[columnIndex];
        const rowss = startdate + Math.floor(index / 4) * rowIncrementt;
        const cell = `${column}${rowss}`;
        worksheet.getCell(cell).value = loc.date;
        worksheet.getCell(cell).alignment = { horizontal: "center" };
        worksheet.getCell(cell).font = { color: { argb: "FF707070" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      });

      for (let i = 0; i < this.totalrows; i++) {
        worksheet.mergeCells(startname, 3, startname, 4);
        worksheet.mergeCells(startname, 5, startname, 6);
        worksheet.mergeCells(startname, 7, startname, 8);
        worksheet.mergeCells(startname, 9, startname, 10);
        worksheet.getCell(`C${startname}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`C${startname}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`E${startname}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`E${startname}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`G${startname}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`G${startname}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`I${startname}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`I${startname}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        startname += rowIncrementt;
      }

      for (let i = 0; i < this.totalrows; i++) {
        worksheet.mergeCells(startpic, 3, startpic, 4);
        worksheet.mergeCells(startpic, 5, startpic, 6);
        worksheet.mergeCells(startpic, 7, startpic, 8);
        worksheet.mergeCells(startpic, 9, startpic, 10);
        worksheet.getCell(`C${startpic}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(`C${startpic}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`E${startpic}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(`E${startpic}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`G${startpic}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(`G${startpic}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`I${startpic}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(`I${startpic}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        startpic += rowIncrementt;
      }

      for (let i = 0; i < this.totalrows; i++) {
        worksheet.mergeCells(startdate, 3, startdate, 4);
        worksheet.mergeCells(startdate, 5, startdate, 6);
        worksheet.mergeCells(startdate, 7, startdate, 8);
        worksheet.mergeCells(startdate, 9, startdate, 10);
        worksheet.getCell(`C${startdate}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(`C${startdate}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`E${startdate}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(`E${startdate}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`G${startdate}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(`G${startdate}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`I${startdate}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(`I${startdate}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        startdate += rowIncrementt;
      }

      for (
        let i = startt;
        i < rowIncrement * this.totalrow;
        i += rowIncrement
      ) {
        worksheet.getCell(`A${i}`).value = "Month";
        worksheet.getCell(`A${i}`).alignment = { horizontal: "center" };
        worksheet.getCell(`A${i}`).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(`A${i}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`A${i}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      }

      for (
        let i = starttt;
        i < rowIncrement * this.totalrow;
        i += rowIncrement
      ) {
        worksheet.mergeCells(i, 1, i + 1, 1);

        console.log("iiii", i);
        worksheet.getCell(`A${i}`).value = "Bal. Last Year";
        worksheet.getCell(`A${i}`).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
        worksheet.getCell(`A${i}`).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(`A${i}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`A${i}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      }

      let monthstart = startmonth;
      for (let i = 0; i < this.totalrow; i++) {
        this.months.forEach((month, index) => {
          const row = monthstart + index;

          console.log("cell", row);
          worksheet.getCell(`A${row}`).alignment = {
            wrapText: true,
            vertical: "middle",
          };
          worksheet.getCell(`A${row}`).value = month;
          worksheet.getCell(`A${row}`).font = { color: { argb: "FF358CCB" } };
          worksheet.getCell(`A${row}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`A${row}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
        });

        monthstart += rowIncrement;
      }

      this.summaries.forEach((summary, index) => {
        const columnIndex = index % 3;
        const column = columns[columnIndex];
        const rowss = startt + Math.floor(index / 3) * rowIncrement;
        const cell = `${column}${rowss}`;
        worksheet.getCell(cell).value = summary.waste;
        worksheet.getCell(cell).alignment = { horizontal: "center" };
        worksheet.getCell(cell).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      });

      let ace = 15;
      for (let i = 0; i < this.totalrow; i++) {
        worksheet.mergeCells(ace, 2, ace, 4);
        worksheet.mergeCells(ace, 5, ace, 7);
        worksheet.mergeCells(ace, 8, ace, 10);

        worksheet.getCell(`B${ace}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`B${ace}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`E${ace}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`E${ace}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`H${ace}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`H${ace}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        ace += rowIncrement;
      }

      let ave = startavg;
      for (let i = 0; i < this.totalrow; i++) {
        worksheet.mergeCells(ave, 2, ave, 4);
        worksheet.mergeCells(ave, 5, ave, 7);
        worksheet.mergeCells(ave, 8, ave, 10);

        worksheet.getCell(`B${ave}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF358CCB" },
        };
        worksheet.getCell(`B${ave}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`E${ave}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF358CCB" },
        };
        worksheet.getCell(`E${ave}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`H${ave}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF358CCB" },
        };
        worksheet.getCell(`H${ave}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        ave += rowIncrement;
      }

      let startRows = {
        jan: 18,
        feb: 19,
        mar: 20,
        apr: 21,
        may: 22,
        jun: 23,
        jul: 24,
        aug: 25,
        sep: 26,
        oct: 27,
        nov: 28,
        dec: 29,
      };

      function applyCellFormatting(worksheet, column, row, value) {
        const cell = `${column}${row}`;

        worksheet.getCell(cell).value = value;
        worksheet.getCell(cell).alignment = { horizontal: "center" };
        worksheet.getCell(cell).font = { color: { argb: "FF707070" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      }

      function getColumnsForField(field) {
        if (field === "gen") return columns;
        if (field === "dis") return columnss;
        if (field === "sto") return columnsss;
      }

      function populateWorksheet(
        worksheet,
        summaries,
        startRow,
        rowIncrement,
        month,
        field
      ) {
        const columns = getColumnsForField(field);

        summaries.forEach((summary, index) => {
          const columnIndex = index % 3;
          const column = columns[columnIndex];
          const row = startRow + Math.floor(index / 3) * rowIncrement;
          applyCellFormatting(worksheet, column, row, summary[month][field]);
        });
      }

      const monthh = [
        "jan",
        "feb",
        "mar",
        "apr",
        "may",
        "jun",
        "jul",
        "aug",
        "sep",
        "oct",
        "nov",
        "dec",
      ];
      const fields = ["gen", "dis", "sto"];

      monthh.forEach((month) => {
        fields.forEach((field) => {
          populateWorksheet(
            worksheet,
            this.summaries,
            startRows[month],
            rowIncrement,
            month,
            field
          );
        });
      });

      //subheader start
      this.summaries.forEach((summary, index) => {
        const columnIndex = index % 3;
        const column = columns[columnIndex];
        const row = 16 + Math.floor(index / 3) * rowIncrement;
        const cell = `${column}${row}`;

        worksheet.getCell(cell).value = "Gen";
        worksheet.getCell(cell).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
        worksheet.getCell(cell).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      });

      this.summaries.forEach((summary, index) => {
        const columnIndex = index % 3;
        const column = columnss[columnIndex];
        const row = 16 + Math.floor(index / 3) * rowIncrement;
        const cell = `${column}${row}`;

        worksheet.getCell(cell).value = "Disp";
        worksheet.getCell(cell).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
        worksheet.getCell(cell).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      });

      // let startdisp = 16;
      // for (let i = 0; i < this.totalrows; i++) {
      //   this.summaries.forEach((summary, index) => {
      //     const columnIndex = index % 3;
      //     worksheet.mergeCells(startdisp, index, startdisp + 1, 4);
      //   worksheet.mergeCells(startdisp, index, startdisp+1, 6);
      //   worksheet.mergeCells(startdisp, 7, startdisp+1, 8);
      //   });

      //   worksheet.mergeCells(startname, 9, startname, 10);
      //   worksheet.getCell(`C${startname}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC5C5C5' } };
      //   worksheet.getCell(`C${startname}`).border = {
      //     top: { style: "thin", color: { argb: "FFFFFFFF" } },
      //     bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
      //     left: { style: "thin", color: { argb: "FFFFFFFF" } },
      //     right: { style: "thin", color: { argb: "FFFFFFFF" } },
      //   };
      //   worksheet.getCell(`E${startname}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC5C5C5' } };
      //   worksheet.getCell(`E${startname}`).border = {
      //     top: { style: "thin", color: { argb: "FFFFFFFF" } },
      //     bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
      //     left: { style: "thin", color: { argb: "FFFFFFFF" } },
      //     right: { style: "thin", color: { argb: "FFFFFFFF" } },
      //   };
      //   worksheet.getCell(`G${startname}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC5C5C5' } };
      //   worksheet.getCell(`G${startname}`).border = {
      //     top: { style: "thin", color: { argb: "FFFFFFFF" } },
      //     bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
      //     left: { style: "thin", color: { argb: "FFFFFFFF" } },
      //     right: { style: "thin", color: { argb: "FFFFFFFF" } },
      //   };
      //   worksheet.getCell(`I${startname}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC5C5C5' } };
      //   worksheet.getCell(`I${startname}`).border = {
      //     top: { style: "thin", color: { argb: "FFFFFFFF" } },
      //     bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
      //     left: { style: "thin", color: { argb: "FFFFFFFF" } },
      //     right: { style: "thin", color: { argb: "FFFFFFFF" } },
      //   };

      //   startname += rowIncrementt;
      // }

      this.summaries.forEach((summary, index) => {
        const columnIndex = index % 3;
        const column = columnsss[columnIndex];
        const row = 16 + Math.floor(index / 3) * rowIncrement;
        const cell = `${column}${row}`;

        worksheet.getCell(cell).value = "Storage";
        worksheet.getCell(cell).alignment = { horizontal: "center" };
        worksheet.getCell(cell).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      });
      //subheader end

      //subheader value start
      this.summaries.forEach((summary, index) => {
        const columnIndex = index % 3;
        const column = columns[columnIndex];
        const row = 17 + Math.floor(index / 3) * rowIncrement;
        const cell = `${column}${row}`;

        worksheet.getCell(cell).alignment = { horizontal: "center" };
        worksheet.getCell(cell).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      });

      this.summaries.forEach((summary, index) => {
        const columnIndex = index % 3;
        const column = columnss[columnIndex];
        const row = 17 + Math.floor(index / 3) * rowIncrement;
        const cell = `${column}${row}`;

        // worksheet.getCell(cell).value = summary.dis.value;
        worksheet.getCell(cell).alignment = { horizontal: "center" };
        worksheet.getCell(cell).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      });

      this.summaries.forEach((summary, index) => {
        const columnIndex = index % 3;
        const column = columnsss[columnIndex];
        const row = 17 + Math.floor(index / 3) * rowIncrement;
        const cell = `${column}${row}`;

        worksheet.getCell(cell).value = summary.sto.value;
        worksheet.getCell(cell).alignment = { horizontal: "center" };
        worksheet.getCell(cell).font = { color: { argb: "FF707070" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      });
      //subheader value end

      let startball = 16;
      let startballl = 17;
      let startcull = 30;

      let sub = ["B", "C", "D", "E", "F", "G", "H", "I", "J"];
      let subbb = ["D", "G", "J"];

      const setCellStyle = (worksheet, cell, fillColor, borderColor) => {
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: fillColor },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: borderColor } },
          bottom: { style: "thin", color: { argb: borderColor } },
          left: { style: "thin", color: { argb: borderColor } },
          right: { style: "thin", color: { argb: borderColor } },
        };
      };

      let rowNumbers = [18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29];

      for (let i = 0; i < this.totalrow; i++) {
        for (let m = 0; m < sub.length; m++) {
          rowNumbers.forEach((row) => {
            setCellStyle(worksheet, `${sub[m]}${row}`, "FFF5F6FA", "FFFFFFFF");
          });
        }
        rowNumbers = rowNumbers.map((row) => row + rowIncrement);
      }

      //cul styling
      for (let i = 0; i < this.totalrow; i++) {
        for (let j = 0; j < sub.length; j++) {
          console.log("merging sini", startball);
          console.log("merging column", j + 2);
          console.log("merging siniii", startball + 1);
          if (j != 2 && j != 5 && j != 8)
            worksheet.mergeCells(startball, j + 2, startball + 1, j + 2);
          worksheet.getCell(`${sub[j]}${startball}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFC5C5C5" },
          };
          worksheet.getCell(`${sub[j]}${startball}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
        }

        for (let k = 0; k < sub.length; k++) {
          worksheet.getCell(`${sub[k]}${startcull}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FF358CCB" },
          };
          worksheet.getCell(`${sub[k]}${startcull}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
        }
        for (let l = 0; l < subbb.length; l++) {
          worksheet.getCell(`${subbb[l]}${startballl}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`${subbb[l]}${startballl}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
        }
        startball += rowIncrement;
        startballl += rowIncrement;
        startcull += rowIncrement;
      }

      //cul start
      this.summaries.forEach((summary, index) => {
        const columnIndex = index % 3;
        const column = columns[columnIndex];
        const row = 30 + Math.floor(index / 3) * rowIncrement;
        const cell = `${column}${row}`;

        worksheet.getCell(cell).value = summary.gen.total;
        worksheet.getCell(cell).alignment = { horizontal: "center" };
        worksheet.getCell(cell).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF358CCB" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      });

      this.summaries.forEach((summary, index) => {
        const columnIndex = index % 3;
        const column = columnss[columnIndex];
        const row = 30 + Math.floor(index / 3) * rowIncrement;
        const cell = `${column}${row}`;

        worksheet.getCell(cell).value = summary.dis.total;
        worksheet.getCell(cell).alignment = { horizontal: "center" };
        worksheet.getCell(cell).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF358CCB" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      });

      this.summaries.forEach((summary, index) => {
        const columnIndex = index % 3;
        const column = columnsss[columnIndex];
        const row = 30 + Math.floor(index / 3) * rowIncrement;
        const cell = `${column}${row}`;

        worksheet.getCell(cell).value = summary.sto.total;
        worksheet.getCell(cell).alignment = { horizontal: "center" };
        worksheet.getCell(cell).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF358CCB" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      });
      //cul end

      let avgg = startavg;
      let tott = starttot;

      for (let i = 0; i < this.totalrow; i++) {
        worksheet.getCell(`A${startcul}`).value = "Cul. Total Tonnage";
        worksheet.getCell(`A${startcul}`).font = {
          color: { argb: "FFFFFFFF" },
        };
        worksheet.getCell(`A${startcul}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF358CCB" },
        };
        worksheet.getCell(`A${startcul}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        worksheet.getCell(`A${avgg}`).value = "Avg. Generation";
        worksheet.getCell(`A${avgg}`).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(`A${avgg}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF358CCB" },
        };
        worksheet.getCell(`A${avgg}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        startcul += rowIncrement;
        avgg += rowIncrement;
      }

      this.summaries.forEach((summary, index) => {
        const columnIndex = index % 3;
        const column = columns[columnIndex];
        const row = startavg + Math.floor(index / 3) * rowIncrement;
        const cell = `${column}${row}`;

        worksheet.getCell(cell).value = summary.average;
        worksheet.getCell(cell).alignment = { horizontal: "center" };
        worksheet.getCell(cell).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF358CCB" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      });

      //section c start here
      let startsectionc = vesselstart - rowIncrementt + this.vessels.length + 1;
      let codec = startsectionc + 1;
      let kgc = codec + 2;

      let startmergecc = startsectionc + 2;
      let startmergecca = startsectionc;
      let startmergeccb = startsectionc + 1;

      const rowIncrementtt = this.cland.length + 2;
      worksheet.mergeCells(startsectionc, 1, startsectionc, 10);
      worksheet.getCell(`A${startsectionc}`).value = "SECTION C : SW OUTGOING";
      worksheet.getCell(`A${startsectionc}`).font = {
        color: { argb: "FFFFFFFF" },
      };
      worksheet.getCell(`A${startsectionc}`).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF358CCB" },
      };

      //ni waste code header
      let startmergeci = startmergecca + 1;
      console.log("merging a", startmergeci);
      for (let i = 0; i < this.totalrowss; i++) {
        worksheet.mergeCells(startmergeci, 3, startmergeci, 4);
        worksheet.mergeCells(startmergeci, 5, startmergeci, 6);
        worksheet.mergeCells(startmergeci, 7, startmergeci, 8);
        worksheet.mergeCells(startmergeci, 9, startmergeci, 10);

        worksheet.getCell(`C${startmergeci}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`C${startmergeci}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`E${startmergeci}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`E${startmergeci}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`G${startmergeci}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`G${startmergeci}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`I${startmergeci}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`I${startmergeci}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        startmergeci += rowIncrementtt;
      }

      let startmergeco = startmergeccb + 1;
      for (let i = 0; i < this.totalrowss; i++) {
        worksheet.mergeCells(startmergeco, 3, startmergeco, 4);
        worksheet.mergeCells(startmergeco, 5, startmergeco, 6);
        worksheet.mergeCells(startmergeco, 7, startmergeco, 8);
        worksheet.mergeCells(startmergeco, 9, startmergeco, 10);

        worksheet.getCell(`C${startmergeco}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(`C${startmergeco}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`E${startmergeco}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(`E${startmergeco}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`G${startmergeco}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(`G${startmergeco}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        worksheet.getCell(`I${startmergeco}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(`I${startmergeco}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        startmergeco += rowIncrementtt;
      }

      //value dalam table styling
      for (let j = 1; j <= this.clandsvalue.length; j++) {
        let startmergec = startmergecc + j;
        for (let i = 0; i < this.totalrowss; i++) {
          worksheet.mergeCells(startmergec, 3, startmergec, 4);
          worksheet.mergeCells(startmergec, 5, startmergec, 6);
          worksheet.mergeCells(startmergec, 7, startmergec, 8);
          worksheet.mergeCells(startmergec, 9, startmergec, 10);

          worksheet.getCell(`C${startmergec}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`C${startmergec}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
          worksheet.getCell(`E${startmergec}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`E${startmergec}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
          worksheet.getCell(`G${startmergec}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`G${startmergec}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
          worksheet.getCell(`I${startmergec}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`I${startmergec}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };

          startmergec += rowIncrementtt;
        }
      }

      //content value dalam table
      let clandstartt = startsectionc + 3;
      this.allcland.forEach((loc, index) => {
        const columnIndex = index % 4;
        const column = columnb[columnIndex];
        const rowss = clandstartt + Math.floor(index / 4) * rowIncrementtt;
        let rowing = rowss;

        for (let i = 0; i < this.clandsvalue.length; i++) {
          worksheet.getCell(`${column}${rowing}`).value =
            loc[i].value == null ? "" : loc[i].value;
          worksheet.getCell(`${column}${rowing}`).alignment = {
            horizontal: "center",
            vertical: "middle",
          };
          worksheet.getCell(`${column}${rowing}`).font = {
            color: { argb: "FF707070" },
          };
          worksheet.getCell(`${column}${rowing}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`${column}${rowing}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };

          rowing++;
        }
      });

      for (let i = 0; i < this.totalrowss; i++) {
        worksheet.mergeCells(codec, 1, codec + 1, 1);
        worksheet.getCell(`A${codec}`).value = "Waste Code & Name";
        worksheet.getCell(`A${codec}`).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
        worksheet.getCell(`A${codec}`).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(`A${codec}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`A${codec}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        worksheet.mergeCells(codec, 2, codec + 1, 2);
        worksheet.getCell(`B${codec}`).value = "Unit";
        worksheet.getCell(`B${codec}`).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
        worksheet.getCell(`B${codec}`).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(`B${codec}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`B${codec}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        worksheet.mergeCells(kgc, 2, kgc + this.cland.length - 1, 2);
        worksheet.getCell(`B${kgc}`).value = "Kg";
        worksheet.getCell(`B${kgc}`).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
        worksheet.getCell(`B${kgc}`).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(`B${kgc}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(`B${kgc}`).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };

        codec += rowIncrementtt;
        kgc += rowIncrementtt;
      }

      let startnamec = startsectionc + 1;
      this.clands.forEach((loc, index) => {
        const columnIndex = index % 4;
        const column = columnb[columnIndex];
        const rowss = startnamec + Math.floor(index / 4) * rowIncrementtt;
        const cell = `${column}${rowss}`;
        worksheet.getCell(cell).value = loc.company;
        worksheet.getCell(cell).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
        worksheet.getCell(cell).font = { color: { argb: "FFFFFFFF" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFC5C5C5" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      });

      let startdatec = startsectionc + 2;
      this.clands.forEach((loc, index) => {
        const columnIndex = index % 4;
        const column = columnb[columnIndex];
        const rowss = startdatec + Math.floor(index / 4) * rowIncrementtt;
        const cell = `${column}${rowss}`;
        worksheet.getCell(cell).value = loc.date;
        worksheet.getCell(cell).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
        worksheet.getCell(cell).font = { color: { argb: "FF707070" } };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F6FA" },
        };
        worksheet.getCell(cell).border = {
          top: { style: "thin", color: { argb: "FFFFFFFF" } },
          bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
          left: { style: "thin", color: { argb: "FFFFFFFF" } },
          right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
      });

      let cvalue = startsectionc + 3;
      for (let i = 0; i < this.totalrowss; i++) {
        this.cland.forEach((land, index) => {
          const row = cvalue + index;
          worksheet.getCell(`A${row}`).value = land.name;
          worksheet.getCell(`A${row}`).alignment = {
            wrapText: true,
            vertical: "middle",
          };
          worksheet.getCell(`A${row}`).font = { color: { argb: "FF707070" } };
          worksheet.getCell(`A${row}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF5F6FA" },
          };
          worksheet.getCell(`A${row}`).border = {
            top: { style: "thin", color: { argb: "FFFFFFFF" } },
            bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
            left: { style: "thin", color: { argb: "FFFFFFFF" } },
            right: { style: "thin", color: { argb: "FFFFFFFF" } },
          };
        });

        cvalue += rowIncrementtt;
      }
      //section c end here

      //footer start here
      let startfoot =
        startsectionc +
        this.cland.length * this.totalrowss +
        2 * this.totalrowss +
        2;
      worksheet.mergeCells(startfoot, 1, startfoot, 2);
      worksheet.getCell(`A${startfoot}`).value = "NOTES ON PRF ACTIVITIES";
      worksheet.getCell(`A${startfoot}`).alignment = { horizontal: "left" };
      worksheet.getCell(`A${startfoot}`).font = {
        bold: true,
        color: { argb: "FF358CCB" },
      };

      worksheet.mergeCells(startfoot + 1, 1, startfoot + 5, 4);
      worksheet.getCell(`A${startfoot + 1}`).border = {
        top: { style: "thin", color: { argb: "FF358CCB" } },
        bottom: { style: "thin", color: { argb: "FF358CCB" } },
        left: { style: "thin", color: { argb: "FF358CCB" } },
        right: { style: "thin", color: { argb: "FF358CCB" } },
      };

      worksheet.mergeCells(startfoot + 7, 1, startfoot + 13, 2);
      worksheet.getCell(`A${startfoot + 7}`).value = "Checked by:";
      worksheet.getCell(`A${startfoot + 7}`).alignment = { vertical: "top" };
      worksheet.getCell(`A${startfoot + 7}`).border = {
        bottom: { style: "thin", color: { argb: "FF707070" } },
      };

      worksheet.getCell(`A${startfoot + 15}`).value = "Name:";
      worksheet.getCell(`A${startfoot + 16}`).value = "Designation:";
      worksheet.getCell(`A${startfoot + 17}`).value = "Date:";

      worksheet.mergeCells(startfoot + 7, 4, startfoot + 13, 6);
      worksheet.getCell(`D${startfoot + 7}`).value = "Verified by:";
      worksheet.getCell(`D${startfoot + 7}`).alignment = { vertical: "top" };
      worksheet.getCell(`D${startfoot + 7}`).border = {
        bottom: { style: "thin", color: { argb: "FF707070" } },
      };
      worksheet.getCell(`D${startfoot + 15}`).value = "Name:";
      worksheet.getCell(`D${startfoot + 16}`).value = "Designation:";
      worksheet.getCell(`D${startfoot + 17}`).value = "Date:";

      worksheet.mergeCells(startfoot + 7, 8, startfoot + 13, 10);
      worksheet.getCell(`H${startfoot + 7}`).value =
        "Received by (Northport HSE):";
      worksheet.getCell(`H${startfoot + 7}`).alignment = { vertical: "top" };
      worksheet.getCell(`H${startfoot + 7}`).border = {
        bottom: { style: "thin", color: { argb: "FF707070" } },
      };
      worksheet.getCell(`H${startfoot + 15}`).value = "Name:";
      worksheet.getCell(`H${startfoot + 16}`).value = "Designation:";
      worksheet.getCell(`H${startfoot + 17}`).value = "Date:";

      worksheet.mergeCells(1, 1, 4, 2);
      worksheet.mergeCells(1, 3, 1, 10);
      worksheet.mergeCells(2, 3, 2, 10);
      worksheet.mergeCells(3, 3, 3, 10);
      worksheet.mergeCells(4, 3, 4, 10);
      worksheet.mergeCells(6, 1, 6, 10);
      worksheet.mergeCells(7, 2, 7, 10);
      worksheet.mergeCells(8, 2, 8, 10);
      worksheet.mergeCells(10, 1, 10, 10);
      worksheet.mergeCells(11, 2, 11, 10);
      worksheet.mergeCells(12, 2, 12, 10);

      worksheet.columns = [
        { width: 23 },
        { width: 13 },
        { width: 13 },
        { width: 13 },
        { width: 13 },
        { width: 13 },
        { width: 13 },
        { width: 13 },
        { width: 13 },
        { width: 13 },
      ];

      worksheet.pageSetup = {
        orientation: "landscape",
        paperSize: 9,
      };

      workbook.eachSheet((worksheet) => {
        const unProtectedColumnIndex = [1];
        const unProtectedRow = [11, 12];

        // Unprotect all cells in the worksheet
        worksheet.eachRow((row) => {
          row.eachCell((cell) => {
            cell.protection = {
              locked: false,
            };
          });
        });

        // Protect cells
        worksheet.columns.forEach((column, columnIndex) => {
          if (!unProtectedColumnIndex.includes(columnIndex)) {
            column.eachCell((cell, rowNumbers) => {
              if (!unProtectedRow.includes(rowNumbers)) {
                cell.protection = { locked: true };
              }
            });
          }
        });

        // Set the sheet protection property
        console.log("set lock property");
        worksheet.protect("", { selectLockedCells: true });
        console.log("set lock property");
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Waste Collection Report.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    createJob(data) {
      this.$router.push("/OutgoingJobPage/create/add");
    },
    getJobPage(data) {
      if (this.producttype == "products") {
        this.$router.push("/Outgoing/" + data.outgoingid);
      } else if (this.producttype == "waste") {
        this.$router.push("/OutgoingJobPage/" + data.outgoingid + "/edit");
      }
    },

    nextaction(data) {
      //   productOrderCreated         = 1
      //   productPendingeCAFPTW       = 2
      //   productPendingSignedDo      = 3
      //   productPendingTerminatedPTW = 4
      //   productCompleted            = 100
      if (this.producttype == "products") {
        this.$router.push("/Outgoing/" + data);
      } else if (this.producttype == "waste") {
        this.$router.push("OutgoingJobPage/" + data + "/edit");
      }
    },
    getData() {
      this.load = false;
      this.tableDatas = [];
      this.temp = [];
      console.log('product type', this.producttype)
      console.log(this.tableDatas.length);
      console.log('tab dia', this.activeTab);

      this.$http
        .get(
          ":10001/api/v1/outgoing/" +
          this.producttype +
          "?company_id=" +
          (this.activeTab == 0 ? this.selects.vendor : this.selects.customer) +
          "&status=" +
          this.selects.status +
          "&page=" +
          this.pagination.currentPage +
          "&size=" +
          this.pagination.perPage +
          "&search=" +
          this.searchQuery +
          "&sort=" +
          this.sortTable +
          "&order=" +
          this.orderTable
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message.items;
            console.log(response);

            if (this.producttype == "products") {
              if (response != null) {
                for (var i = 0; i < response.length; i++) {
                  console.log("hewwo");
                  let obj = {
                    index:
                      i +
                      1 +
                      this.pagination.perPage *
                      (this.pagination.currentPage - 1),
                    outgoingid: response[i].outgoing_id,
                    jobno: response[i].reference_number,
                    // datecreated: moment(response[i].created_at).format(
                    // "DD MMM YYYY"
                    // ),
                    datecreated: response[i].created_at,
                    customer:
                      response[i].company != null
                        ? response[i].company.company_name
                        : "",
                    readydate:
                      response[i].order_ready_at === null
                        ? "-"
                        : response[i].order_ready_at,
                    // moment(response[i].order_ready_at).format(
                    // "DD MMM YYYY"
                    // ),
                    statusname: response[i].status.name,
                    statuscode: response[i].status.status,
                    statuscolor: response[i].status.status_color,
                    ptwname: response[i].ptw_status.name,
                    ptwcolor: response[i].ptw_status.status_color,
                  };
                  console.log(obj);
                  this.tableDatas.push(obj);
                  this.temp.push(obj);
                }
              }
            }

            if (this.producttype == "waste") {
              if (response != null) {
                for (var i = 0; i < response.length; i++) {
                  let obj = {
                    index:
                      i +
                      1 +
                      this.pagination.perPage *
                      (this.pagination.currentPage - 1),
                    jobno:
                      response[i].reference_number == ""
                        ? "-"
                        : response[i].reference_number,
                    outgoingid: response[i].outgoing_id,
                    // datecreated: moment(response[i].created_at).format(
                    //   "DD MMM YYYY"
                    // ),
                    datecreated: response[i].created_at,
                    vendor:
                      response[i].company != null
                        ? response[i].company.company_name
                        : "None",
                    // collectiondate: moment(response[i].order_ready_at).format(
                    //   "YYYY-MM-DD"
                    // ),
                    collectiondate: response[i].order_ready_at,
                    appstatus: response[i].appointment.status,
                    appname: response[i].appointment.name,
                    appcolor: response[i].appointment.status_color,
                    ptwstatus: response[i].ptw_status.status,
                    ptwname: response[i].ptw_status.name,
                    ptwcolor: response[i].ptw_status.status_color,
                    cnstatus: response[i].cn_status.status,
                    cnname: response[i].cn_status.name,
                    cncolor: response[i].cn_status.status_color,
                    invoicestatus: response[i].invoice_status.status,
                    invoicename: response[i].invoice_status.name,
                    invoicecolor: response[i].invoice_status.status_color,
                    statusname: response[i].status.name,
                    statuscode: response[i].status.status,
                    statuscolor: response[i].status.status_color,
                  };
                  this.tableDatas.push(obj);
                  this.temp.push(obj);
                }
              }
            }

            // pagination
            console.log(res.message);
            this.pagination.total = res.message.total;
            console.log(this.pagination.total);
          }
        });
    },
  },
  created() {
    this.getServiceLocation();
    this.selects.date = [moment().startOf("y"), moment().endOf("y")];
    // this.getSummary();

    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );

    // get session tab
    if (sessionStorage.getItem("outgoingtab") == "waste") {
      this.activeTab = 0;
    } else if (sessionStorage.getItem("outgoingtab") == "products") {
      this.activeTab = 1;
    } else {
      this.activeTab = 0;
    }
  },
  computed: {
    cangenerate() {
      return (
        this.selects.servicelocation === "" ||
        this.selects.month === "" ||
        this.selects.year === ""
      );
    },
    queriedData() {
      let result = this.tableDatas;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableDatas.length;
    },
  },
  watch: {
    "selects.date"() {
      this.daterange =
        moment(this.selects.date[0]).format("MMM") +
        " - " +
        moment(this.selects.date[1]).format("MMM YYYY");
    },
    searchQuery: debounce(function (search) {
      this.getData();
      // console.log(search);
      // if (search != "") {
      //   this.tableDatas = this.temp.filter((value) =>
      //     value.jobno.toLowerCase().includes(search.toLowerCase())
      //   );
      // } else {
      //   this.tableDatas = this.temp;
      // }
    }, 500),
    activeTab() {
      console.log('tab mana', this.activeTab);

      if (this.activeTab == 0) {
        this.selects.status = '';
        this.selects.vendor = '';
        // waste
        this.producttype = "waste";
        this.getVendor();
        this.getData();
        this.getStatus();
      }
      if (this.activeTab == 1) {
        this.selects.status = '';
        this.selects.customer = '';
        // product
        this.producttype = "products";
        this.getCustomer();
        this.getData();
        this.getStatus();
      }

      sessionStorage.setItem("outgoingtab", this.producttype);
    },
    "pagination.currentPage"() {
      console.log(this.pagination.currentPage);
      this.getData();
    },
    "pagination.perPage"() {
      this.getData();
    },
    // "pagination.total"(){
    //   console.log(this.pagination.total)
    // }
  },

  mounted() {
    // this.fuseSearch = new Fuse(this.tableDatas, {
    //   keys: ["jobno"],
    //   threshold: 1.0,
    // });
  },
};
</script>
<style>
.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}

.custom-dropdown .el-select-dropdown {
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-table .el-table__body td,
.custom-table .el-table__header th {
  color: #A5A5A5 !important;
}

.job-no-title {
  color: #358CCB;
  text-decoration: none;
}

.job-no-title:hover {
  color: #358CCB;
  text-decoration: underline;
  cursor: pointer;
}

.job-no-title3 {
  color: #A5A5A5;
  text-decoration: none;
}

.job-no-title3:hover {
  color: #A5A5A5;
  /* text-decoration: underline; */
  /* cursor: pointer; */
}

textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

.textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}
</style>
